// extracted by mini-css-extract-plugin
export default {"container":"MKlJd9PQoE","message":"Fd7eR+YCI3","error":"K9j2DaJRRq","icon":"x53vWwwcOb","value":"_6mcIdlVQDG"};